module.exports = __webpack_public_path__ + "media/assets/icons/twitter-cde0eeebcbf2c3d75e5858dcc8d9cf58.svg";